export default "__VITE_ASSET__psCXiSjj__"